import {ITeamRoleService} from "@common/service/teamRole.service";
import angular from "angular";
import {CommonService} from "@common/common.service";
import {UtilityService} from "@common/service/util.service";
import {BroadcastService} from "@common/service/broadcast.service";
import {IAppRootScopeService} from "@app/app.definition";
import {PopUpService} from "@common/popup/popup.service";
import {CachingService} from "@common/service/caching.service";
import {JavaApiAdapterService} from "@common/apiadapter/javaapi.service";
import {CacheService} from "@common/service/cache.service";
import {EnterpriseService} from "@common/service/enterprise.service";
import {WalkThroughItem, WalkThroughService} from "@common/service/walkTrough.service";
import {PermissionsEnum, PermissionService, TargetEnum} from "ecv/common/permissions";
import {TeamService} from "@common/service/team.service";
import _ from "lodash";
import {MEMBER_STATUS} from "@common/model/subject";
import {Util} from "@common/util";
import {User, UserNotiTypeEnum} from "@common/model/user";
import {PostTypeEnums} from "@common/model/_adocument";
import {OrgUsers} from "@common/model/organization";
import {Discussion} from "@common/model/discussion";
import {FormUser} from "@common/model/formUser";
import {Form} from "@common/model/form";

export const SHARE_ITEM_TYPE = {
    DISCUSSION: 'discussion',
    DOCUMENT: 'document',
    FORM: 'form',
    SERVICE: 'service',
    SERVICE_NOTE: 'note'
}

export interface IEcvShareItem {
    init: Function;
}

class EcvShareItem implements IEcvShareItem {
    item;
    isItemArray;
    itemOwner;
    sharedUsers;
    eligibleUsers;
    TMCondition;
    teamMembers;
    participants;
    participantsOrgs;
    pOrgsWithSelected;
    pMembersWithSelected;
    selectedMembers;
    hasSelectedEntities;
    selectedOrgs = [];
    hasForm;
    shareMode;
    isConvertible;
    currentUser;
    currentOrg;
    formerUsrTooltip;
    formerActiveUsrTooltip;
    formFormerUsrTooltip;
    displayAs;
    memberStatus;
    selMember;
    permissions;
    selPermission;
    noSharedMembersMsg;
    addTmOption;
    isCaptainOrCoCaptain;
    shareFlag;
    reShareFlags;
    updateFlags;
    shareLoader;
    iconBgColor;
    searchText;
    selectedItem;
    newItem;
    lockedMode;
    iconColor;
    uNotification;
    tourInProgress;
    reshareMsg;
    updateMsg;
    msgs;
    shrCnfrm;
    dsblSlctAll = true;
    isAllSelected = false;
    isAddTMpermited = false;
    isSharePermited;
    unAssignFlag = false;
    memberListToShow;
    unAssignedMembers;
    unAssignTooltip;
    unAssignConfirmTooltip;
    resetStateMsg;

    autoCmpltContainer;
    autoCmpltInrContainer;
    isConfirmScreen;
    confirmMsg;
    textConfig;
    isDocumentFlow;
    isFormFlow;
    isFormWthRoles;
    hasOrgData;
    organizations;
    inPopupMsg;
    formerOrgTooltip;
    formerActiveOrgTooltip;
    currentSubj;
    discTooltip: string;
    reshareDeletedTooltip : string;
    updateMsgOrg : string;
    reshareOrgDeletedTooltip : string;
    lockedPermissionTypes: {} = {
        viewOnly: [
            {
                text: 'View Only',
                value: 'VIEW',
                icon: 'fa-eye',
                color: '#288726'
            },
            {
                text: 'View & Download',
                value: 'ACCESS',
                icon: 'fa-download',
                color: '#288726'
            },
            {
                text: 'Author',
                value: 'OWN',
                icon: 'fa-lock',
                color: '#000000'
            },
            {
                text: 'Deleted',
                value: 'DELETED',
                icon: 'fa-trash',
                color: '#BD362F'
            }
        ],
        viewOnlyLink: [
            {
                text: 'View Only',
                value: 'VIEW',
                icon: 'fa-eye',
                color: '#288726'
            },
            {
                text: 'View & Share',
                value: 'ACCESS',
                icon: 'fa-share-alt',
                color: '#288726'
            },
            {
                text: 'Author',
                value: 'OWN',
                icon: 'fa-lock',
                color: '#000000'
            },
            {
                text: 'Deleted',
                value: 'DELETED',
                icon: 'fa-trash',
                color: '#BD362F'
            }
        ],
        form: [
            {
                text: 'Assignor',
                value: 'ASSIGNOR',
                svg: require("../../../../../assets/images/svg/user-shield.svg"),
                color: '#000000'
            },
            {
                text: 'Fill-out Form',
                value: 'ASSIGNEE',
                parentRole: 'ASSIGNEE',
                svg: require("../../../../../assets/images/svg/user-pencil.svg"),
                color: '#288726'
            },
            {
                text: 'View Submission',
                value: 'VIEWER',
                icon: 'fa-eye',
                color: '#288726'
            }
        ],
        discussion: [
            {
                text: 'Author',
                value: 'OWN',
                icon: 'fa-lock',
                color: '#000000'
            },
            {
                text: 'Participant',
                value: 'ACCESS',
                icon: 'fa-eye',
                color: '#288726'
            },
            {
                text: 'Deleted',
                value: 'DELETED',
                icon: 'fa-trash',
                color: '#BD362F'
            }
        ],
        default: [
            {
                text: 'Author',
                value: 'OWN',
                icon: 'fa-lock',
                color: '#000000'
            },
            {
                text: 'Deleted',
                value: 'DELETED',
                icon: 'fa-trash',
                color: '#BD362F'
            },
            {
                text: 'View Only',
                value: 'VIEWONLY',
                icon: 'fa-eye',
                color: '#288726'
            },
            {
                text: 'Viewer',
                value: 'VIEWER',
                icon: 'fa-eye',
                color: '#288726'
            },
            {
                text: 'Shared',
                value: 'ACCESS',
                icon: 'fa-eye',
                color: '#288726'
            },
            {
                text: 'Provider',
                value: 'PROVIDER',
                icon: 'fa-briefcase',
                color: '#000000'
            },
            {
                text: 'Assignor',
                value: 'ASSIGNOR',
                icon: 'fa-lock',
                color: '#000000'
            },
            {
                text: 'Assignee',
                value: 'ASSIGNEE',
                icon: 'fa-lock',
                color: '#000000'
            }
        ]
    };
    permissionTypes: {} = {
        viewOnly: [
            {
                text: 'View & Download',
                value: 'ACCESS',
                icon: 'fa-download',
                color: '#288726',
            },
            {
                text: 'View Only',
                value: 'VIEW',
                icon: 'fa-eye',
                color: '#288726'
            }
        ],
        viewOnlyLink: [
            {
                text: 'View & Share',
                value: 'ACCESS',
                icon: 'fa-share-alt',
                color: '#288726',
            },
            {
                text: 'View Only',
                value: 'VIEW',
                icon: 'fa-eye',
                color: '#288726'
            }
        ],
        form: [
            {
                text: 'Fill-out Form',
                value: 'ASSIGNEE',
                parentRole: 'ASSIGNEE',
                svg: require("../../../../../assets/images/svg/user-pencil.svg"),
                color: '#288726'
            },
            {
                text: 'View Submission',
                value: 'VIEWER',
                icon: 'fa-eye',
                color: '#288726'
            }
        ],
        discussion: [
            {
                text: 'Participation',
                value: 'ACCESS',
                icon: 'fa-eye',
                color: '#288726'
            }
        ],
        default: [
            {
                text: 'View Only',
                value: 'ACCESS',
                icon: 'fa-eye',
                color: '#288726'
            }
        ]
    };
    entityStatus: {} = {
        not_shared: {
            text: 'Not Shared',
            value: 'NOT_SHARED',
            icon: 'fa-eye-slash',
            color: '#FF6563'
        },
        pending: {
            text: 'Pending',
            value: 'PENDING',
            icon: 'fa-times',
            color: '#000000'
        }
    }
    addTeamMemberService: any = null;

    static $inject = ["$scope", "EnterpriseService", "CacheService", "TeamService", "ApiAdapterService",
        "CachingService", "PopUpService", "$uibModal", "$mdSelect", "$rootScope", "$timeout",
        "BroadcastService", "$q", "CommonService", "UtilityService", "WalkThroughService", "$compile", 
        "PermissionService", "TeamRoleService", "ConditionalModuleLoadService"];

    constructor(
        private $scope : angular.IScope,
        private $_entSvc : EnterpriseService,
        private $_cache : CacheService,
        private TeamService : TeamService,
        private $_api : JavaApiAdapterService,
        private $_caching : CachingService,
        private $_pop : PopUpService,
        private $uibModal : angular.ui.bootstrap.IModalService,
        private $mdSelect :any,
        private $rootScope : IAppRootScopeService,
        private $timeout : angular.ITimeoutService,
        private BroadcastService : BroadcastService,
        private $q : angular.IQService,
        private $_common : CommonService,
        private $util : UtilityService,
        private WalkThroughService : WalkThroughService,
        private $compile : ng.ICompileService,
        private PermissionService : PermissionService,
        private $_teamRoleService: ITeamRoleService,
        private conditionalModuleLoadService: IConditionalModuleLoadService
    ) {
        BroadcastService.registerCallBack('share-entities', $scope.$id, () => {
            this.share();
        });
        BroadcastService.registerCallBack('confirm-screen-toggled', $scope.$id, () => {
            if (this.isDocumentFlow) {
                if (this.isConfirmScreen) {
                    this.inPopupMsg = ''; // hide the message on next screen
                }
                this.setOrgs();
            }
            this.setMembers();
        });
        BroadcastService.registerCallBack('doc-disc-delete-updates', $scope.$id, (docId, callerId, orgId) => {
            if (this.item.id == docId) {
                if (!!orgId) {
                    let org = this.participantsOrgs.find((o) => o.id == orgId);
                    if (!!org) {
                        let pm = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == 'DELETED');
                        org.permissionObj = pm;
                        org.users.forEach(u => {
                            u.permissionObj = pm;
                            u.isDocDeleted = true;
                        });
                        this.setFormerParams(org);
                    }
                } else {
                    let tm = this.participants.find((u) => u.userId == callerId);
                    if (!!tm) {
                        tm.isDocDeleted = true;
                        tm.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == 'DELETED');
                    }
                    this.setMembers();
                }
            }
        });
        this.$scope.$on('$destroy', () => {
            BroadcastService.removeCallBack('share-entities', $scope.$id);
            BroadcastService.removeCallBack('doc-disc-delete-updates', $scope.$id);
            BroadcastService.removeCallBack('confirm-screen-toggled', $scope.$id);
            window.removeEventListener('resize', this.$_common.setIsMobile);
            if (this.isDocumentFlow && this.isWalkthroughEnabled()) {
                this.toggleClickSubscription(false);
            }
        });
        this.conditionalModuleLoadService.getAddTeamMemberService().then((service) => { this.addTeamMemberService = service;});
    }

    selclicked = function (elemId, drpdwnCnt) {
        let elem = $("#" + elemId);
        let containerTop = elem[0].getBoundingClientRect().top + elem.height() + "px";
        setTimeout(function () {
            $("." + drpdwnCnt).css({'top': containerTop});
        }, 50);

    };

    setOrgs = () => {
        let arr = [];
        if (this.isConfirmScreen) {
            arr = [...this.selectedOrgs]
        } else {
            if (this.currentOrg) {
                arr.push(this.currentOrg);
            }
            arr = [...arr, ...this.selectedOrgs, ...this.participantsOrgs];
        }
        this.pOrgsWithSelected = this.getGridAray(arr);
    };

    getGridAray = (arr) => {
        let rtnArr = [];
        for (let i = 0; i < arr.length; i += 2) {
            let r = [];
            r.push(arr[i], arr[i + 1]);
            rtnArr.push(r);
        }
        return rtnArr;
    }

    setMembers = () => {
        let arr , memberShowArr: any[];
        if (this.isConfirmScreen) {
            let selectedMembersClone = _.cloneDeep([...this.selectedMembers]);

            selectedMembersClone.forEach(member => {
                let index = this.participants.findIndex(user => user.providerIdentity === member.providerIdentity);
                if (index !== -1) {
                    member.permArr = _.uniqBy(member.permArr.concat(this.participants[index].permArr), 'value');
                }
            });

            memberShowArr = _.cloneDeep([...selectedMembersClone]);
            arr = [...this.selectedMembers];
        } else {

            let participantsClone = _.cloneDeep([...this.participants]);
            this.selectedMembers.forEach(member => {
                let index = participantsClone.findIndex(user => user.providerIdentity === member.providerIdentity);
                if (index !== -1) {
                    participantsClone[index].permArr = participantsClone[index].permArr.concat(member.permArr);
                    participantsClone[index].status = member.status;
                } else {
                    participantsClone.push(member);
                }
            });

            participantsClone.forEach(p => {
                p.permArr = _.uniqBy(p.permArr, 'value');
            })

            memberShowArr = [...participantsClone];
            arr = [...this.selectedMembers, ...this.participants];
        }
        this.memberListToShow = this.getGridAray(memberShowArr);
        this.pMembersWithSelected = this.getGridAray(arr);
    }

    getSelectPlaceholder = () => {
        return "<span class=\"fa fa-user-plus\" aria-hidden=\"true\"></span> Select Team Members";
    }

    setAllSelected = () => {
        let tIndex = this.teamMembers.findIndex(tm => !tm.selected);
        let oIndex = -1;

        if (this.hasOrgData) {
            oIndex = this.organizations.findIndex(o => !o.selected);
        }

        this.isAllSelected = (tIndex == -1 && oIndex == -1);
    }

    changeSelection = (entity, fromAC, isOrg = false, unAssignAction = false) => {
        if (fromAC) {
            if (entity) {
                this.selectedItem = null;
            } else {
                // here autocomplete's selected value is being cleared at that time also this event would be catched
                // but at that time the item would be null so nothing to do in that case
                return;
            }
            // if object is org object then it does not have key userId
            isOrg = this.isDocumentFlow && !entity.userId;
        }
        let key = this.getKeyForEntity(isOrg);
        entity.selected = (entity.status != 'pending');
        this.fetchTMStatus(entity[key], entity.selected, key, isOrg, unAssignAction);
        this.setAllSelected();
        this.setHasSelectedEntities();
        if (isOrg) {
            this.setOrgs();
            this.manageNextWTFlow(entity.selected);
        } else {
            this.setMembers();
        }
    }

    showWTMsgs = () => {
        if (this.tourInProgress) {
            this.WalkThroughService.nextItem(this.WalkThroughService.currentIndex + 1);
        } else {
            this.WalkThroughService.removeTooltip();
            this.toggleClickSubscription(false);
            this.uNotification.isDeleted = true;
            this.$_api.updateUserNotificationAlertFlag(this.uNotification);
            this.WalkThroughService.reset();
        }
    };

    unAssignAction = (member) => {
        member.permArr.forEach(perm => {
            perm['unassign'] = true;
        });

        member.status = 'pending'
        this.unAssignedMembers.push(member.userId);
        this.selectedMembers.push(member);

        this.setHasSelectedEntities();
        this.setMembers();
    }

    toggleStyle = (member) => {
        if (!!member.unAssignFlag) {
            member.toggleStyle = false;
        } else {
            member.toggleStyle = true;
            setTimeout(() => {
                member.toggleStyle = false;
            }, 10000);
        }
    }

    toggleSelectAll = () => {
        this.isAllSelected = !this.isAllSelected;
        let processToggling = (collection, key, isOrg) => {
            _.each(collection, (entity) => {
                if ((entity.status == 'pending' && !this.isAllSelected) || (entity.status == "not_shared" && this.isAllSelected)) {
                    this.fetchTMStatus(entity[key], this.isAllSelected, key, isOrg);
                    entity.selected = this.isAllSelected;
                }
            });
        }
        processToggling(this.teamMembers, this.getKeyForEntity(false), false);

        if (this.hasOrgData) {
            processToggling(this.organizations, this.getKeyForEntity(true), true);
            this.setOrgs();
            this.manageNextWTFlow(this.isAllSelected);
        }
        this.setHasSelectedEntities();
        this.setMembers();
    }

    manageNextWTFlow = (selected : boolean) => {
        if (!this.isWalkthroughEnabled()) {
            return;
        }
        if (selected) {
            (this.WalkThroughService.currentIndex == 0) && this.showWTMsgs();
        } else if (this.selectedOrgs.length == 0) {
            // complete the flow
            this.tourInProgress = false;
            this.showWTMsgs();
        }
    }

    getKeyForEntity = (isOrg) => {
        return (this.isDocumentFlow && isOrg ? "id" : "userId");
    }

    removeSelectedTM = (entityId, isOrg) => {
        let key = this.getKeyForEntity(isOrg);
        let process = (collection) => {
            let entity = collection.find(t => t[key] == entityId);
            entity.selected = false;
        }
        this.isAllSelected = false;
        this.fetchTMStatus(entityId, false, key, isOrg, true);
        if (isOrg) {
            process(this.organizations);
            this.setOrgs();
        } else {
            let index = this.unAssignedMembers.findIndex(id => id === entityId);
            if (index > -1) {
                this.unAssignedMembers.splice(index, 1);
            }
            process(this.teamMembers);
            this.setMembers();
        }
        this.setHasSelectedEntities();
    }

    init(): void {
        this.selectedMembers = [];
        this.memberStatus = (MEMBER_STATUS.INVITED | MEMBER_STATUS.FORMER);
        this.currentUser = this.$_cache.getUser();
        this.currentSubj = this.$_cache.getCurrentSubject();
        this.isDocumentFlow = (this.displayAs == SHARE_ITEM_TYPE.DOCUMENT);
        this.isFormFlow = (this.displayAs == SHARE_ITEM_TYPE.FORM);
        this.isFormWthRoles = (this.isFormFlow && this.item.roles);
        this.discTooltip = Util.SHARE_WITH_DISC_INFO;
        this.formerUsrTooltip = Util.RESHARE_FORMER_USER.replace(/displayAs/g, this.displayAs);
        this.formerActiveUsrTooltip = Util.RESHARE_FORMER_ACTIVE_USER.replace(/displayAs/g, this.displayAs);
        this.formFormerUsrTooltip = Util.RESHARE_FORM_FORMER_USER;
        this.noSharedMembersMsg = Util.NO_SHARED_USERS_MSG.replace(/displayAs/g, this.displayAs);
        this.reshareDeletedTooltip = Util.RESHARE_DELETED_INFO.replace(/displayAs/g, this.displayAs);
        this.reshareOrgDeletedTooltip = Util.RESHARE_DELETED_INFO_ORG.replace(/displayAs/g, this.displayAs);
        this.formerOrgTooltip = Util.RESHARE_FORMER_ORG;
        this.formerActiveOrgTooltip = Util.RESHARE_FORMER_ACTIVE_ORG;
        this.reshareMsg = Util.RESHARE_DELETED_DOC;
        this.updateMsg = "Click 'Confirm' to complete the update of $TMName's version of $ItemTitle."
        this.updateMsgOrg = "Click 'Confirm' to share the most current version of this Document.";
        this.shrCnfrm = "Double check who you are sharing this with!<br /> Make any changes or click 'Confirm' to continue.";
        this.resetStateMsg = "Undo all changes to this Team Member’s assignment.";
        this.unAssignTooltip = "Remove this Team Member’s access. This will take place after clicking ‘Next’ and saving.";
        this.unAssignConfirmTooltip = "Click again to confirm you would like to remove access for this Team Member.";
        this.iconColor = "#ffffff";
        this.isSharePermited = this.item.userPerm ? this.item.userPerm.share : false;
        this.uNotification = null;
        this.unAssignedMembers = [];
        this.selMember = [];
        this.isItemArray = Array.isArray(this.item)
        let replacements = this.textConfig.msgVars;
        this.confirmMsg = `${replacements["var1"]} cannot be revoked so please be sure any Team Members you ${replacements["var2"]} are allowed ${replacements["var3"]}.`
        if (Array.isArray(this.currentUser.userNotifications)) {
            this.uNotification = this.currentUser.userNotifications.find(n => n.notificationType == UserNotiTypeEnum.SHARE_WALK_THROUGH);
        }
        if (!!this.addTmOption) {
            let teamPartyId = !!this.currentSubj ? this.currentSubj.teamPartyId : null;
            this.isUserCaptainOrCoCaptain();
            if (this.isItemArray) {
                !!this.item[0].subject && (teamPartyId = this.item[0].subject.teamPartyId);
                this.setNewPermissionFlags(teamPartyId)
            } else {
                !!this.item.subject && (teamPartyId = this.item.subject.teamPartyId);
                this.setNewPermissionFlags(teamPartyId)
            }
        }
        if (this.isItemArray) {
            for (let i = 0; i < this.item.length; i++) {
                this.isConvertible = this.isConvertibleToPdf(this.item[i] || null);
                if (!this.isConvertible) {
                    break;
                }
            }
        } else {
            this.isConvertible = this.isConvertibleToPdf(this.item || null);
        }

        this.$_entSvc.hasForms().then(() => {
            this.hasForm = !!this.$_cache.getFeatures().forms;
            this.shareMode = this.lockedMode = 'viewOnly';
            if (!this.isDocumentFlow) {
                if (!!this.item.formUsers) {
                    this.shareMode = 'form';
                    this.lockedMode = 'form';
                } else if (this.displayAs == SHARE_ITEM_TYPE.DISCUSSION) {
                    this.shareMode = 'discussion';
                    this.lockedMode = 'discussion';
                } else {
                    this.shareMode = 'default';
                    this.lockedMode = 'default';
                }
            }
            if (this.item.postType == PostTypeEnums.LINK) {
                this.shareMode = this.lockedMode = 'viewOnlyLink'
            }

            if (this.isFormWthRoles) {
                this.permissionTypes[this.shareMode] = [];
                this.lockedPermissionTypes[this.lockedMode] = [];
                this.item.roles.forEach(r => {
                    let role = {};
                    role['text'] = r.label;
                    role['value'] = r.role;
                    if (r.role == 'ASSIGNOR') {
                        role['svg'] = require("../../../../../assets/images/svg/user-shield.svg");
                        role['color'] = '#000000';
                        role['order'] = 1;
                    } else if (r.role == 'VIEWER') {
                        role['icon'] = 'fa-eye';
                        role['color'] = '#288726';
                        role['order'] = 3;
                    } else if (r.parentRole == 'ASSIGNEE' || r.role == 'ASSIGNEE') {
                        role['svg'] = require("../../../../../assets/images/svg/user-pencil.svg");
                        role['color'] = '#288726';
                        role['order'] = 2;
                        role['parentRole'] = 'ASSIGNEE';
                    }
                    r.role != 'ASSIGNOR' && (this.permissionTypes[this.shareMode].push(role));
                    this.lockedPermissionTypes[this.lockedMode].push(role);
                });
            }


            let item = (this.isItemArray ? this.item[0] : this.item)
            if (!!item.owner) {
                this.itemOwner = item.owner;
            } else {
                this.itemOwner = item.assignor;
            }
            //Filter out the current user and users who are former members,
            // who have been added but not invited yet and whose invitation has expired.
            //For forms - do not filter out the current user if share is permitted
            //For forms - do not filter out the current user if self assign is permitted
            //For services and service notes - filter out current user if he is item owner

            this.TMCondition = (eu) => {
                return !eu.isFormerTeamMember && (!!this.isFormWthRoles || (this.isFormFlow && this.isSharePermited) || (this.isSharePermited && this.itemOwner.id != this.currentUser.id) || eu.id != this.currentUser.id) && ((!!eu.invitation && eu.invitation.status != 'EXPIRED') || (!eu.invitation && eu.isActive));
            }
            this.teamMembers = this.eligibleUsers.filter(this.TMCondition)


            if (this.isFormFlow && item.userPerm[PermissionsEnum.SELF_ASSIGN] && !item.subject.isActiveMember) {
                let CrUserTMIndex = this.teamMembers.findIndex(tm => tm.id === this.currentUser.id);
                if (CrUserTMIndex === -1) {
                    this.currentUser.teamRole = "Administrator"
                    this.teamMembers.push(new User().deserialize(this.currentUser))
                }
                this.eligibleUsers.push(new User().deserialize(this.currentUser))
            }

            this.hasOrgData = false;
            if (this.isDocumentFlow) {
                this.organizations = [];
                this.selectedOrgs = [];
                this.participantsOrgs.length = 0;
                //following line will keep only non org user or individual users in teamMembers collection
                let orgUsers = _.remove(this.teamMembers, (user) => user.organizationId != 0 && !user.isIndividualMember);
                this.prepareOrgs(orgUsers);
                window.addEventListener('resize', this.$_common.setIsMobile);
                this.$_common.setIsMobile();
            }

            // this.fetchAllTMStatus();

            //If current user is not assignor of the form or if it a submitted form then show only view permission
            //or current user has experience of share mode as view submission
            let isShareModeViewSubmission = Util.safeAccess(this.$_cache.getUserExperience(), ['features', 'assignedForms', 'shareMode']);
            if (this.isFormFlow && ((this.item.assignorId != this.currentUser.id && !this.isSharePermited) || this.item.status == 'SUBMITTED' || (isShareModeViewSubmission == 'VIEW_SUBMISSION'))) {
                this.permissions = [];
                this.permissions.push(this.permissionTypes[this.shareMode].find((pt) => pt.value == 'VIEWER'))
            } else if (this.isDocumentFlow && (!this.isConvertible || !this.hasForm || this.item.rawDocSize > Util.DOCSIZE_THRESOLD) && this.item.postType == PostTypeEnums.DOCUMENT) {
                this.permissions = [];
                this.permissions.push(this.permissionTypes[this.shareMode].find((pt) => pt.value == 'ACCESS'));
            } else {
                this.permissions = this.permissionTypes[this.shareMode];
            }
            this.selPermission = this.permissions[0];
            this.fetchAllTMStatus(); // Update list users also
            if (this.isDocumentFlow) {
                if (!!this.currentUser && !!this.currentUser.organizationId) {
                    let index = this.organizations.findIndex(o => o.id == this.currentUser.organizationId);
                    if (index == -1) {
                        // this block will be executed when
                        // there is no other team member having same org as current user in that case prepare org
                        // from current user
                        this.prepareOrgs([this.currentUser]);
                        // here we always get the index so no need to check for empty index
                        index = this.organizations.findIndex(o => o.id == this.currentUser.organizationId);
                    }
                    this.currentOrg = this.organizations.splice(index, 1)[0];
                    this.currentOrg.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == 'ACCESS');
                    this.currentOrg.permissionType = "ACCESS";
                    this.currentOrg.isCurrentUserOrg = true;
                }
                this.hasOrgData = (this.organizations.length > 0);
                this.setOrgs();
            }
            this.setPermissions();
            this.setMembers();
            this.permChange();

            if (this.isDocumentFlow && this.isWalkthroughEnabled()) {
                this.initWalkThrough();
            }

            for (let index in this.lockedPermissionTypes[this.lockedMode]) {
                let permission = this.lockedPermissionTypes[this.lockedMode][index];
                this.entityStatus[permission.value.toLowerCase()] = permission;
            }
        });
        this.$rootScope.mainShowLoader = false;
        this.$timeout(() => {
            let outer = $('.share-autocmplt-dropdown');
            this.autoCmpltContainer = (outer[0] as HTMLElement ).style;
            this.autoCmpltContainer.minHeight = '48px';
            this.autoCmpltInrContainer = (outer.find('.md-virtual-repeat-sizer')[0] as HTMLElement).style;
        });
    }


    prepareOrgs = (users, isParticipantOrg = false) => {
        let process = (targetCollection) => {
            let usersByOrg = _.groupBy(users, (u) => u.organizationId);
            for (let key in usersByOrg) {
                let org = new OrgUsers(usersByOrg[key]);
                org.orgValue = "org_" + org.id;
                org.users = _.orderBy(org.users, ['isActive', 'lastName', 'firstName'], ['desc', 'asc', 'asc'])
                targetCollection.push(org);
            }
        }
        if (isParticipantOrg) {
            process(this.participantsOrgs);
        } else {
            process(this.organizations);
            this.hasOrgData = (this.organizations.length > 0);
        }
    }

    toggleClickSubscription = (isSubscription, mltplBackDrop = true) => {
        let popupClicked = () => {
            if (this.tourInProgress) {
                this.$timeout(() => {
                    this.tourInProgress = (this.WalkThroughService.currentIndex == 1);
                    this.showWTMsgs();
                }, 0);
            } else {
                this.toggleClickSubscription(false);
            }
        }
        let selector = '.modal.share-container';
        if (mltplBackDrop) {
            selector += ', .md-select-backdrop.md-click-catcher';
        }
        if (isSubscription) {
            $(selector).on('click', popupClicked);
        } else {
            $(selector).off('click', popupClicked);
        }
    }

    isWalkthroughEnabled = () => {
        return (_.isObject(this.uNotification) && (!( this.uNotification as any ).isDeleted));
    }

    initWalkThrough = () => {
        let getTemplateString = (obj) => {
            let str = "<div class='wtcntnr'>";
            if (obj.title) {
                str += `<div class="wt-title">
                                ${obj.title}
                            </div>`
            }
            str += `<div class="wt-desc">
                                ${obj.desc}
                            </div>
                        </div>`;
            return str;
        }

        let msgs = {
            teamDD: {
                title: 'New to Sharing - Care Orgs! What is a Care Org?',
                desc: 'Org is short for Organization - these are the healthcare groups, school districts, or other group of professionals providing care on your Team.'
            },
            topPanel: {
                desc: 'Sharing with Care Orgs allows these organizations to give additional, necessary access to their team of professionals providing care for your team. You can see each Care Org with access in the area above.'
            },
            bottomPanel: {
                desc: 'You can always view which members of a Care Org have access to your information by ' + (this.$_common.isMobile ? 'tapping on' : 'hovering over') + ' <span class="binfo"><i class="fa fa-users"></i> Team Members With Access</span> located below each Care Org\'s listing. <div class="btm">That\'s It! Click anywhere to continue.</div>'
            }
        };

        let traverseItems = [
            new WalkThroughItem(1, getTemplateString(msgs.teamDD), 'general-share-popup', 'wt-ref', 'wt-sharepopup', 550, 110, undefined, 0),
            new WalkThroughItem(2, getTemplateString(msgs.topPanel), 'general-share-popup', 'wt-ref', 'wt-sharepopup', 550, 110, undefined, 0),
            new WalkThroughItem(3, getTemplateString(msgs.bottomPanel), 'general-share-popup', 'wt-ref', 'wt-sharepopup', 550, 110, undefined, 5)
        ];

        this.WalkThroughService.reset();
        this.WalkThroughService.init(traverseItems, this.$compile, this.$scope , null);

        this.$timeout(() => {
            if (this.$_common.isMobile) {
                let width = window.innerWidth - 2;
                traverseItems.forEach(item => item.width = width);
            }

            this.tourInProgress = true;
            if (this.currentOrg || this.participantsOrgs.length > 0) {
                this.showWTMsgs();
                this.toggleClickSubscription(true, false);
            } else {
                this.$timeout(() => {
                    this.WalkThroughService.nextItem(0);
                    $('#team-mem-drpdwn').click();
                    this.$timeout(() => {
                        this.toggleClickSubscription(true);
                    }, 0);
                }, 200);
            }
        }, 0)
    }

    isConvertibleToPdf = (d: Discussion): boolean => {
        return !!d && !!d.filename && 'doc,docx,xls,xlsx,ppt,pptx,rtf,odt,ods,odp,pdf'.split(',').find(ft => !!d.filename.toLowerCase().endsWith('.' + ft)) != null;
    }

    setPermissions = () => {
        this.participants = this.participants.filter(p => {
            return !!this.eligibleUsers.find((u) => u.id == p.id) &&
                ((p.permissionType != 'OWN' && p.permissionType != 'ASSIGNOR') || p.id != this.currentUser.id);
        });

        for (let user of this.participants) {
            user.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == user.permissionType);
            let tMem = this.eligibleUsers.find((u) => u.id == user.id);
            user.teamRole = tMem.teamRole;
            user.permissionEndDate = tMem.permissionEndDate;
            user.isFormerTeamMember = tMem.isFormerTeamMember;
            user.providerStatus = tMem.providerStatus;
            user.isDocDeleted = tMem.isDocDeleted;
            user.organizationId = tMem.organizationId;
            user.isIndividualMember = tMem.isIndividualMember;
            user.organizationName = tMem.organizationName;
            user.organizationShortName = tMem.organizationShortName;
            user.isActive = tMem.isActive;
            if (user.isDocDeleted) {
                user.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == 'DELETED');
            }
        }

        if (this.isFormFlow) {
            this.participants = _.reduce(this.participants, (arr, crntUsr) => {
                let usr = arr.find(u => u.id == crntUsr.id);
                if (!usr) {
                    (crntUsr['permArr'] || (crntUsr['permArr'] = [])).push(crntUsr['permissionObj']);
                    arr.push(crntUsr);
                } else {
                    (usr['permArr'] || (usr['permArr'] = [])).push(crntUsr['permissionObj']);
                }
                return arr;
            }, []);
        }

        if (this.isDocumentFlow) {
            let pOrgs = _.remove(this.participants, p => p.organizationId != 0 && !p.isIndividualMember);
            this.prepareOrgs(pOrgs, true);
            if (this.participantsOrgs.length > 0) {
                if (this.currentOrg) {
                    // current org should be already there so remove current org
                    _.remove(this.participantsOrgs, o => o.id == this.currentOrg.id);
                    let index = this.currentOrg.users.findIndex(u => u.id == this.currentUser.id);
                    if (index == -1) {
                        this.currentOrg.users.unshift(this.currentUser);
                    }

                }
                this.participantsOrgs.forEach((po) => {
                    po.permissionObj = po.users[0].permissionObj;
                    po.permissionType = po.users[0].permissionType;
                    this.setFormerParams(po);
                });
                this.fetchAllTMStatus()
                this.setOrgs();
            }
        }
    }

    setFormerParams = (po) => {
        po.isFormerOrg = ((po.users.filter(u => u.isFormerTeamMember)).length == po.users.length);
        if (po.isFormerOrg) {
            po.providerStatus = MEMBER_STATUS.FORMER;
        } else {
            let formerInvited = po.users.filter(u => _.includes([MEMBER_STATUS.INVITED, MEMBER_STATUS.FORMER, this.memberStatus], u.providerStatus));
            po.providerStatus = (formerInvited.length == po.users.length) ? (MEMBER_STATUS.FORMER | MEMBER_STATUS.INVITED) : MEMBER_STATUS.ACTIVE;
        }
        po.permissionEndDate = (po.users.find(u => !!u.permissionEndDate) || {}).permissionEndDate;
        po.isDocDeleted = (po.users.find(u => !!u.isDocDeleted) || {}).isDocDeleted;
        po.showUpdateLink = !po.isFormerOrg && po.providerStatus != this.memberStatus && !!po.permissionEndDate;
        po.showReshareLink = !po.isFormerOrg && po.providerStatus != this.memberStatus && !po.permissionEndDate && po.isDocDeleted;
    }

    textChangeSearch = (searchText : string ) => {
        let outerModal = $('.share-container');
        if (!!searchText && searchText.length != 0) {
            outerModal.css("overflow-y", "hidden");
        } else {
            outerModal.css("overflow-y", "auto");
        }
    }

    focusSearch = (searchText : string) => {
        let outerModal = $('.share-container');
        if (!!searchText && searchText.length != 0) {
            outerModal.css("overflow-y", "hidden");
        } else {
            outerModal.css("overflow-y", "auto");
        }
    }
    blurSearch = (event) => {
        let outerModal = $('.share-container');
        outerModal.css("overflow-y", "auto");
    }
    querySearch = (criteria) => {
        this.$timeout(() => {
            let inrHght = parseInt(this.autoCmpltInrContainer.height);
            if (inrHght > parseInt(this.autoCmpltContainer.minHeight) && inrHght < parseInt(this.autoCmpltContainer.maxHeight)) {
                this.autoCmpltContainer.height = this.autoCmpltInrContainer.height;
            }
        }, 0);
        let result = [];
        if (criteria) {
            let lowerCaseQuery = criteria.toLowerCase();
            let filterCollection = (collection, key) => {
                return collection.filter(c => c[key].toLowerCase().indexOf(lowerCaseQuery) !== -1 && c.status == 'not_shared');
            }
            result = filterCollection(this.teamMembers, "fullName");
            if (this.hasOrgData) {
                let orgs = filterCollection(this.organizations, "name");
                result = [...orgs, ...result];
            }
        }
        return result;
    }

    fetchTMStatus = (entityId, selected, key, isOrg, removeAllPerm = false) => {
        let processStatus = (collection, targetCollection) => {
            let entity = collection.find((e) => {
                return e[key] == entityId
            });
            const viewSubmissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == "VIEWER");
            if (selected) {
                entity.permissionType = this.selPermission.value;
                entity.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == this.selPermission.value);
                entity.status = "pending";
                if (this.isFormFlow) {
                    (entity['permArr'] || (entity['permArr'] = [])).push(entity['permissionObj']);

                    // Adding view submission as a default share type
                    (viewSubmissionObj in entity['permArr']) || entity['permArr'].push(viewSubmissionObj);

                    let tgtEntity = targetCollection.find(t => {
                        return t[key] == entityId
                    });
                    if (!!tgtEntity) {
                        (tgtEntity['permArr'] || (tgtEntity['permArr'] = [])).push(entity['permissionObj']);
                    } else {
                        targetCollection.push(angular.copy(entity));
                    }
                    entity['permArr'] = _.uniq(entity['permArr']);
                } else {
                    targetCollection.push(entity);
                }
            } else {
                entity.status = "not_shared";
                if (this.isFormFlow) {
                    if (removeAllPerm || (entity['permArr'].length < 3 && this.selPermission.value != viewSubmissionObj.value)) {
                        entity['permArr'] = [];
                        _.remove(targetCollection, (e) => {
                            return e[key] == entityId
                        });
                    } else {
                        _.remove(entity['permArr'], (p) => {
                            return p.value == this.selPermission.value
                        });
                        if (entity['permArr'].length > 0) {
                            let tgtEntity = targetCollection.find(t => {
                                return t[key] == entityId
                            });
                            _.remove(tgtEntity['permArr'], (p) => {
                                return p.value == this.selPermission.value
                            });
                            tgtEntity.permissionType = entity['permArr'][0]['value'];
                            tgtEntity.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == entity['permArr'][0]['value']);
                            tgtEntity.status = "pending";
                        } else {
                            _.remove(targetCollection, (e) => {
                                return e[key] == entityId
                            });
                        }
                    }
                } else {
                    _.remove(targetCollection, (e) => {
                        return e[key] == entityId
                    });
                }
            }
        }
        if (this.isDocumentFlow && isOrg) {
            processStatus(this.organizations, this.selectedOrgs);
        } else {
            processStatus(this.teamMembers, this.selectedMembers);
        }
    }

    setHasSelectedEntities = () => {
        this.hasSelectedEntities = (this.selectedMembers.length + (this.isDocumentFlow ? this.selectedOrgs.length : 0)) > 0;
    };

    fetchAllTMStatus = () => {
        this.dsblSlctAll = true;
        let process = (collection, refCollection, comparisonKey) => {
            collection.forEach(entity => {
                let eMember = refCollection.find((sharedUser) => {
                    return sharedUser[comparisonKey] == entity[comparisonKey]
                });
                if (!!eMember) {
                    if (this.isFormFlow && !!eMember['permArr']) {
                        let pm = eMember['permArr'].find(p => p.value == this.selPermission.value || (this.selPermission.value == "VIEWER" && (p.parentRole == "ASSIGNEE" || p.value == "ASSIGNOR")));
                        if (!!pm) {
                            entity.status = this.selPermission.value.toLowerCase();
                            entity.selected = true;
                            entity.isImplicitViewer = (pm.value !== this.selPermission.value && this.selPermission.value == "VIEWER" && (pm.parentRole == "ASSIGNEE" || pm.value == "ASSIGNOR"));
                        } else {
                            entity.status = "not_shared";
                            entity.selected = false;
                            this.dsblSlctAll = false;
                        }
                    } else {
                        entity.status = eMember.permissionType.toLowerCase();
                        entity.selected = true;
                        entity.isImplicitViewer = !['VIEWER'].includes(eMember.permissionType);
                    }
                } else {
                    entity.status = "not_shared";
                    entity.selected = false;
                    this.dsblSlctAll = false;
                }
            });
        }
        process(this.teamMembers, this.participants, "userId");
        if (this.isDocumentFlow) {
            process(this.organizations, this.participantsOrgs, "orgValue");
            //sort orgs
            this.organizations.forEach(o => o.sortPref = this.sortPreference(o.status));
            this.organizations = _.orderBy(this.organizations, ['sortPref', 'name'], ['asc', 'asc']);
        }
        //if all are selected then show Deselect All btn
        if (!!this.dsblSlctAll) {
            this.isAllSelected = true;
        }
        this.sortTeamMembers();
    }
    refreshTM = () => {
        return this.$timeout(() => {
            this.$scope.$broadcast("$md-resize");
        }, 100);

    }
    permChange = () => {
        this.fetchAllTMStatus();
        let process = (collection, refCollection, comparisonKey) => {
            collection.forEach(entity => {
                let eMember = refCollection.find((sharedUser) => {
                    return sharedUser[comparisonKey] == entity[comparisonKey]
                });
                if (!!eMember) {
                    if (!!eMember['permArr']) {
                        let pm = eMember['permArr'].find(p => p.value == this.selPermission.value);
                        if (!!pm) {
                            entity.status = 'pending';
                            entity.selected = true;
                        }
                    }
                }
            });
        }
        process(this.teamMembers, this.selectedMembers, "userId");
    }
    sortPreference = (status) => {
        if (status == "not_shared") {
            return 1;
        } else if (status == "view") {
            return 2;
        } else {
            return 3;
        }
    }
    sortTeamMembers = () => {
        this.teamMembers = this.teamMembers.sort((a, b) => this.sortPreference(a.status) > this.sortPreference(b.status) ? 1 : this.sortPreference(a.status) < this.sortPreference(b.status) ? -1 : 0);
        this.teamMembers = this.teamMembers.sort((a, b) => (this.sortPreference(a.status) != this.sortPreference(b.status)) ? 0 : (a.lastName > b.lastName) ? 1 : ((b.lastName > a.lastName) ? -1 : 0));
        this.teamMembers = this.teamMembers.sort((a, b) => ((this.sortPreference(a.status) != this.sortPreference(b.status)) || (a.lastName != b.lastName)) ? 0 : (a.firstName > b.firstName) ? 1 : ((b.firstName > a.firstName) ? -1 : 0));
    }

    isUserCaptainOrCoCaptain = () => {
        let subject = this.$_cache.getCurrentSubject();
        if (!subject) {
            subject = (this.isItemArray ? this.item[0].subject : this.item.subject);
        }
        this.TeamService.isUserCaptain(subject.subjectId).then(
            () => {
                this.isCaptainOrCoCaptain = true;
            },
            () => {
                this.isCaptainOrCoCaptain = false;
            }
        )
    }
    setNewPermissionFlags = (partyId) => {
        this.PermissionService.isActionAllowed(partyId, TargetEnum.TEAMMEMBER, PermissionsEnum.CREATE).then((isPermited) => {
            this.isAddTMpermited = isPermited
        })
    }
    addNewTM = () => {
        this.$mdSelect.hide();
        let $acElement = angular.element(document.getElementById('share_autocmplt'));
        let acCtrl = $acElement.controller('mdAutocomplete');
        acCtrl.hidden = true;
        this.searchText = "";
        this.selectedItem = null;
        this.$_common.showInvitationMsg = false;
        let subj = this.currentSubj;
        !subj && (subj = this.isItemArray ? this.item[0].subject : this.item.subject);
        this.addTeamMemberService.openAddTeamMemberPopup(subj, this.sharedUsers, this.displayAs).then((s) => {
            s.teamRole = Util.safeAccess(this.$_teamRoleService.getTeamRoleById(s.teamRoleId, subj.teamOrgId), ['roleName ']);
            s.permissionType = 'NOT_SHARED';
            s.status = "not_shared";
            let addedTM = angular.copy(s);
            let singleUserProcess = (tm) => {
                this.teamMembers.push(tm);
                this.changeSelection(tm, false);
                this.dsblSlctAll = false;
            }
            if (this.isDocumentFlow) {
                this.$_common.showInvitationMsg = false;
                let obj = {firstName: addedTM.firstName, orgName: addedTM.organizationName};
                let msg: string;
                if (s.organizationId > 0 && !addedTM.isIndividualMember) {
                    let org = this.organizations.find(o => o.id == s.organizationId);
                    if (org) {
                        org.users.push(addedTM);
                    } else if (!!this.currentOrg && addedTM.organizationId == this.currentOrg.id) {
                        this.currentOrg.users.push(addedTM);
                    } else {
                        // in case of former org it possible that the org will be present in participant orgs
                        org = this.participantsOrgs.find(o => o.id == addedTM.organizationId);
                        if (org) {
                            // following 2 lines required here as backend can not provide that for invited member
                            addedTM.isFormerTeamMember = false;
                            addedTM.providerStatus = MEMBER_STATUS.INVITED;
                            org.users.push(addedTM);
                            this.setFormerParams(org);
                            let o = _.cloneDeep(org);
                            o.selected = true;
                            o.status = org.permissionType.toLowerCase();
                            this.organizations.push(o);
                        } else {
                            this.prepareOrgs([addedTM]);
                            this.fetchTMStatus(addedTM.organizationId, false, this.getKeyForEntity(true), true);
                        }
                    }
                    msg = Util.SHARE_POPUP_ORG_USER_ADDED;
                } else {
                    singleUserProcess(addedTM);
                    msg = Util.SHARE_POPUP_NON_ORG_USER_ADDED;
                }
                msg = msg.interpolate(obj);
                if (this.$_common.isMobile) {
                    toastr.success(msg, '', {timeOut: 5000})
                } else {
                    this.inPopupMsg = msg;
                }
                this.$_common.showInvitationMsg = true;
            } else {
                singleUserProcess(addedTM);
            }
        }, (e) => {
            console.log(e);
        });
    }

    addParticipant = (user) => {
        let tMem = this.teamMembers.find((u) => u.id == user.id);
        if (!!tMem) {
            user.teamRole = tMem.teamRole;
        }
        if (this.isFormFlow) {
            let usr = this.participants.find(u => u.id == user.id);
            if (!usr) {
                (user['permArr'] || (user['permArr'] = [])).push(user['permissionObj']);
                this.participants.push(user);
            } else {
                (usr['permArr'] || (usr['permArr'] = [])).push(user['permissionObj']);
            }
        } else {
            this.participants.push(user);
        }
    }

    reShare = (entity, action, isOrg = false) => {
        if (action == 'update') {
            this.updateFlags[isOrg ? entity.orgValue : entity.id] = false;
        } else {
            this.reShareFlags[entity.id] = false;
        }
        this.shareLoader = 'Please wait...';
        if (isOrg) {
            let orgShareMap = {};
            orgShareMap[entity.id] = entity.permissionType;
            this.shareDocument({}, true, orgShareMap);
        } else {
            let userShareMap = {};
            userShareMap[entity.id] = entity.permissionType;
            this.shareDocument(userShareMap, true);
        }
    }

    shareDocument = (userShareMap, isReshared = false, orgShareMap = {}) => {
        let subj = this.item.subject || this.currentSubj;
        this.$_api.shareDocument(this.item.id, this.$_cache.getPassword(), userShareMap, orgShareMap, this.item.postType, !this.item.subject, subj.subjectId).then(
            (responseData) => {
                if (!!this.item.subject) {
                    //update the document users in the cache
                    let docUsers = this.item.documentUsers;
                    for (let du of responseData.documentUsers) {
                        let docUsrIdx = docUsers.findIndex(u => u.id == du.id);
                        let user = new User().deserialize(du);
                        if (docUsrIdx > -1) {
                            docUsers.splice(docUsrIdx, 1, user);
                            let participant = this.participants.find(p => p.id == du.id);
                            if (!!participant) {
                                participant.isDocDeleted = false;
                                participant.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == participant.permissionType);
                                participant.permissionEndDate = 0;
                            } else {
                                user.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == user.permissionType);
                                this.addParticipant(user);
                            }
                        } else {
                            docUsers.push(user);
                            user.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == user.permissionType);
                            this.addParticipant(user);
                        }
                    }
                    if (isReshared && !!Object.keys(orgShareMap)) {
                        let pOrg = this.participantsOrgs.find(po => po.id == +Object.keys(orgShareMap));
                        if (pOrg) {
                            pOrg.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == pOrg.permissionType);
                            pOrg.users.forEach(u => {
                                u.permissionEndDate = 0;
                                u.isDocDeleted = false;
                            });
                            this.setFormerParams(pOrg);
                        }
                    }
                    this.$_caching.addOrUpdateDocuments([this.item]);
                }


                this.setMembers();
                if (!!this.item['discussionId']) {
                    let msg = '';
                    let entity = this.$util.capitalize(this.displayAs);
                    if (!!responseData.sharedFailedUsersIds) {
                        msg = `${entity} shared but not with all users. Please try again or contact support.`;
                    } else if (!!responseData.sharedUsersIds || !!responseData.sharedOrgIds) {
                        msg = `The ${entity} was successfully shared.`;
                    }
                    if (!!msg) {
                        toastr.success(msg);
                    }
                }
                if (!isReshared) {
                    this.closeSharePopup();
                    this.selectedMembers = [];
                    this.fetchAllTMStatus();
                }

                this.shareLoader = false;
            }, (e) => {
                this.$_pop.openInformationModal(e);
                this.shareLoader = false;
            });
    }

    shareForm = () => {
        let addFormUser = (su, users) => {
            let u = users.find(u => u.id == su.userId);
            u.permissionType = su.getPermission(this.item.roles);
            u.isActive = su.isActive;
            u.unassign = su.unassign;
            su.role = su.getPermission(this.item.roles);
            su.user = u;
            su = new FormUser(su);
            this.item.formUsers.push(su);
            let fmuser = su.user;
            fmuser.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == su.getPermission(this.item.roles));
            this.addParticipant(fmuser);
        };

        let updateFormUsers = (userIds, someFailed) => {
            this.$_caching.getUsers(userIds).then(
                (users: User[]) => {
                    if (someFailed) {     //if some failed, only add those users with whom the form was successfully shared.
                        for (let su of sendForm.formUsers) {
                            if (!!userIds.find(uid => uid == su.userId)) {
                                addFormUser(su, users);
                            }
                        }
                    } else {
                        for (let su of sendForm.formUsers) {
                            addFormUser(su, users);
                        }
                    }
                    this.unAssignedMembers.forEach(member => {
                        _.remove(this.item.formUsers, (u) => u['userId'] === member);
                        _.remove(this.participants, (u) => u['userId'] === member);
                        _.remove(this.selectedMembers, (u) => u['userId'] === member);
                    })
                    this.item._getFormNonAssignors();
                    this.item._getFormAssignees();
                    this.fetchAllTMStatus();

                    if (someFailed) {
                        toastr.success(`You've successfully shared the Form with some users,
                                    however there were some errors. Please check who it's shared with and try again.`, null, 7000);
                    } else {
                        let words = sendFormObj.formUsers.length > 1 ? " with all users" : ""
                        toastr.success("You've successfully shared the Form" + words + ".", null, 7000);
                    }
                    this.closeSharePopup();
                },
                () => {
                    if (someFailed) {
                        let words = sendFormObj.formUsers.length > 1 ? "You've successfully shared the Form with some or all users however there were some errors" : "Oops, something may have gone wrong sharing the Form"
                        toastr.success(words + `. Please check who it's shared with and try again.`, null, 7000);
                    } else {
                        toastr.success(`You've successfully shared the Form with some or all users,
                                    however there were some errors. Please check who it's shared with and try again.`, null, 7000);
                    }
                }
            );
        };

        let sendForm = {
            assignmentId: this.item.assignmentId,
            subjectId: this.item.subjectId,
            formUsers: []
        };

        for (let m of this.selectedMembers) {
            m['permArr'].forEach(pm => {
                let newFormUser = new FormUser({
                    userId: m.id,
                    role: pm.value,
                    isActive: m.isActive,
                    unassign: pm.unassign
                });
                newFormUser.role = newFormUser.getPermission(this.item.roles); //normalize to permission terminology.
                sendForm.formUsers.push(Object.assign({}, newFormUser));
            });
        }

        let sendFormObj = Object.assign({password: null}, sendForm);
        sendFormObj.password = this.$_cache.getPassword();
        this.$_api.addUsersToForm(sendFormObj).then(
            (s: Form) => {
                let anyFailed = !!s;
                if (anyFailed) {
                    let userIds: number[] = !!s.formUsers ? s.formUsers.map(fu => fu.userId) : [];
                    updateFormUsers(userIds, true);
                } else {
                    let userIds: number[] = !!sendForm.formUsers ? sendForm.formUsers.map(fu => fu.userId) : [];
                    updateFormUsers(userIds, false);
                }
            }, () => {
                toastr.success(`That didn't go right! We couldn't share the form with some or all users,
                         please check who it's shared with and try again.`, null, 7000);
            }
        ).finally(() => {
            this.selectedMembers = [];
            this.shareLoader = false;
        });
    }

    shareService = (shareWith) => {
        let deferred = this.$q.defer();
        if (this.displayAs == SHARE_ITEM_TYPE.SERVICE) {
            this.$_api.shareService(this.item.assignedServiceId, shareWith).then(
                (s) => {
                    //Update assigned users
                    for (let sharedId of s.successUserIds) {
                        let sharedUser = this.selectedMembers.find(o => !!o ? o['id'] == sharedId : null);
                        if (!!sharedUser) {
                            let serviceUsers = this.item.assignedUsers;
                            sharedUser.permissionType = 'VIEWONLY';
                            this.item.assignedUsers = serviceUsers.concat(sharedUser);
                            sharedUser.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == 'VIEWONLY');
                            this.addParticipant(sharedUser);
                        }
                    }
                    deferred.resolve(s);
                }, (e) => {
                    deferred.reject(e);
                }
            );
        } else if (this.displayAs == SHARE_ITEM_TYPE.SERVICE_NOTE) {
            this.$_api.shareServiceNote(this.item.assignedServiceId, this.item.id, shareWith, this.$_cache.getPassword()).then(
                (s) => {
                    //Update assigned users
                    for (let sharedId of s.successUserIds) {
                        let sharedUser = this.selectedMembers.find(o => !!o ? o['id'] == sharedId : null);
                        if (!!sharedUser) {
                            let serviceUsers = this.item.serviceUsers;
                            sharedUser.permissionType = 'VIEWER';
                            this.item.serviceUsers = serviceUsers.concat(sharedUser);
                            sharedUser.permissionObj = this.lockedPermissionTypes[this.lockedMode].find((pt) => pt.value == 'VIEWER');
                            this.addParticipant(sharedUser);
                        }
                    }
                    deferred.resolve(s);
                }, (e) => {
                    deferred.reject(e);
                }
            );
        }
        return deferred.promise;
    }

    closeSharePopup = () => {
        this.BroadcastService.broadcast('close-share-popup')
    }

    share = () => {
        this.shareFlag = false;
        if (this.newItem) {
            for (let user of this.selectedMembers) {
                this.participants.push(user);
                let teamMember = this.teamMembers.find((tm) => {
                    return tm.userId == user.userId
                });
                teamMember.status = user.permissionObj.value.toLowerCase();
            }
            this.selectedMembers = [];
            this.participantsOrgs.push(...this.selectedOrgs);
            this.selectedOrgs = [];
            this.fetchAllTMStatus();
            this.closeSharePopup();
        } else {
            if (this.isFormFlow) {
                this.shareLoader = 'Saving Permissions';
                this.shareForm();
            } else if (this.displayAs == SHARE_ITEM_TYPE.SERVICE || this.displayAs == SHARE_ITEM_TYPE.SERVICE_NOTE) {
                this.shareLoader = 'Please wait...';
                let shareWith = [];
                let toastMsg = "";
                for (let m of this.selectedMembers) {
                    shareWith.push({"id": m.id});
                }
                this.shareService(shareWith).then((s : any) => {
                    let successCount = s.successUserIds.length;
                    let failedUsers = "";
                    toastMsg = 'This ' + this.displayAs;
                    if (s.successUserIds.length > 0) {
                        toastMsg += ' has been successfully shared with ' +
                            successCount + ' ' + (successCount > 1 ? 'members' : 'member') + '.';
                        if (!!s.failedUserIds && s.failedUserIds.length > 0) {
                            toastMsg += ' But';
                        }
                        this.closeSharePopup();
                    }

                    if (!!s.failedUserIds && s.failedUserIds.length > 0) {
                        let tUser = this.selectedMembers.find(o => !!o ? o['id'] == s.failedUserIds[0] : null);
                        failedUsers += tUser.fullName;
                        for (let i = 1; i < s.failedUserIds.length; i++) {
                            let tUser = this.selectedMembers.find(o => !!o ? o['id'] == s.failedUserIds[i] : null);
                            failedUsers += ", " + tUser.fullName;
                        }
                        toastMsg += " could not be shared with " + failedUsers;
                    }
                }, () => {
                    toastMsg = 'Unable to share this ' + this.displayAs + '. Please try again.';
                }).finally(() => {
                    this.shareLoader = false;
                    this.selectedMembers = [];
                    this.fetchAllTMStatus();
                    toastr.success(toastMsg);
                });
            } else {
                this.shareLoader = 'Please wait while we securely share your ' + this.displayAs + '.';
                let orgShareMap = {}, userShareMap = {};
                for (let m of this.selectedMembers) {
                    userShareMap[m.id] = m.permissionObj.value;
                }
                if (this.isDocumentFlow) {
                    this.selectedOrgs.forEach(org => {
                        orgShareMap[org.id] = org.permissionType;
                    })
                }
                this.shareDocument(userShareMap, false, orgShareMap);
            }
        }
    }
}

function ecvShareItem(): ng.IDirective {
    return {
        restrict: 'E',
        templateUrl: 'app/common/share/components/shareItem/share-item.directive.html',
        replace: true,
        controller: EcvShareItem,
        scope: true,
        controllerAs: 'shareItemVm',
        bindToController: {
            'item': '=',
            'headerIcon': '=',
            'iconBgColor': '@',
            'sharedUsers': '=',
            'participants': '=',
            'participantsOrgs': '=',
            'currentOrg': '=',
            'eligibleUsers': '=',
            'hasSelectedEntities': '=',
            'displayAs': '@',
            'addTmOption': '=',
            'newItem': '=',
            'msgs': '=',
            'isConfirmScreen': '=',
            'textConfig': '='
        },
        link: (scope: ng.IScope, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: IEcvShareItem): void => {
            controller.init();
        }
    };
}

angular.module('eCareVault.common.share').directive('ecvShareItem', ecvShareItem).directive('customChip', function () {
    return {
        restrict: 'A',
        link: function (scope, elem, attrs) {
            let chipClass = (scope as any).$chip.chipClass;
            let mdChip = elem.parent().parent();
            mdChip.addClass(chipClass);
        }
    }
});
